export class AccountTreeNode {
  children: any[];
  name: string;
  subTitle?: string;
  value: number;
  expanded = false;
}
